
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...slugs]]",
      function () {
        return require("private-next-pages/blog/[[...slugs]].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...slugs]]"])
      });
    }
  